import { useCallback } from 'react';
import useAppSelector from './useAppSelector';
import { PermissionType } from 'utils/constants/permissions';

interface UseAppPermissionProps {
    allow: (code: PermissionType) => boolean;
}
const useAppPermission = (): UseAppPermissionProps => {
    const permissions = useAppSelector(state => state.auth.permissions);
    const allow = useCallback((code: PermissionType): boolean => {
        // return true;
        return permissions.findIndex(p => p.code === code) >= 0;
    }, [permissions])
    return {
        allow
    }
}

export default useAppPermission;